import React from 'react';
import ErrorBoundary from '.';

export function withErrorBoundary<TProps = any>(
  Component: React.ComponentType<TProps>,
  debugComponent
) {
  const decorated: React.FC<TProps> = props => (
    <ErrorBoundary debugComponent={debugComponent}>
      <Component {...props} key={`${debugComponent}ErrorBoundary`} />
    </ErrorBoundary>
  );
  decorated.displayName = `withErrorBoundary(${Component.displayName || 'Component'})`;
  return decorated;
}
